import { useState, useEffect, useCallback, useRef } from "react";
import { Button, Image } from "semantic-ui-react";

// Components
import CustomerInfoHeader from "react-lib/apps/MEH/CustomerInfoHeader";
import CardMeBillingMenuContent, {
  CardMeBillingMenuContentProps,
  MENU_KEYS,
  MENUS,
  MenuKey,
  STAFF_ONLY_MENUS,
} from "react-lib/apps/MEH/CardMeBillingMenuContent";
import MeBillingCustomerActions, {
  MeBillingCustomerActionsRef,
} from "react-lib/apps/MEH/MeBillingCustomerActions";

// Config
import { ADMIN_NAME_LIST } from "react-lib/apps/USER/CardSettingDivision";

type CardMeBillingDetailProps = Omit<CardMeBillingMenuContentProps, "menu" | "onSelectMenu"> & {
  onGoBack: () => void;
  initialMenu?: string;
};

const IMAGES = {
  goback: "/static/images/meBilling/icon_goback.png",
};

const CardMeBillingDetail = (props: CardMeBillingDetailProps) => {
  const [selectedMenu, setSelectedMenu] = useState<MenuKey>(
    props.isMePOSCRM ? MENU_KEYS.PRODUCT_SERVICE : MENU_KEYS.REGISTER_SERVICE,
  );

  const customerActionsRef = useRef<MeBillingCustomerActionsRef>(null);

  useEffect(() => {
    if (props.initialMenu) {
      setSelectedMenu(props.initialMenu as MenuKey);
      props.setProp("meBillingInitialMenu", "");
    }
  }, [props.initialMenu]);

  const menuList = props.isMePOSCRM
    ? [MENU_KEYS.PRODUCT_SERVICE, MENU_KEYS.PAYMENT_HISTORY]
    : MENUS;

  const handleSelectMenu = useCallback((menu: MenuKey) => {
    setSelectedMenu(menu);
  }, []);

  const menuStyle = useCallback(
    (active: boolean) => ({
      fontSize: "16px",
      marginBottom: "20px",
      cursor: "pointer",
      width: "max-content",
      paddingLeft: active ? "10px" : "13px",
      ...(active && {
        color: "var(--primary-theme-color)",
        borderLeft: "3px solid var(--primary-theme-color)",
      }),
    }),
    [],
  );

  return (
    <div style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
      {/* --- Go Back --- */}
      <div style={{ marginBottom: "0rem" }}>
        <Button
          style={{
            backgroundColor: "transparent",
          }}
          size="small"
          onClick={props.onGoBack}
        >
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Image src={IMAGES.goback} />
            ย้อนกลับ
          </div>
        </Button>
      </div>

      {/* --- Customer Info --- */}
      <CustomerInfoHeader
        customer={props.selectedCustomer}
        // proxyPatient={props.selectedProxyPatient}
        onEdit={() => customerActionsRef.current?.onEdit()}
        onChat={() => customerActionsRef.current?.onChat()}
        onLinkUserId={() => customerActionsRef.current?.onLinkUserId()}
        languageUX={props.languageUX}
      />
      <MeBillingCustomerActions
        ref={customerActionsRef}
        hideButtons
        setProp={props.setProp}
        runSequence={props.runSequence}
        selectedCustomer={props.selectedCustomer}
        masterData={props.masterData}
        masterOptions={props.masterOptions}
        buttonLoadCheck={props.buttonLoadCheck}
        languageUX={props.languageUX}
        // เปิดเมนูแชท (แอป MeHey) ที่ห้องของผู้รับบริการรายนี้
        onChat={() => props.setProp("goToAdminMenu", ADMIN_NAME_LIST.แชท)}
      />

      {/* --- Menu ---- */}
      <div style={{ display: "flex", width: "100%", height: "max-content" }}>
        <div style={{ width: "15%", padding: "15px" }}>
          {menuList
            .filter((menu) =>
              props.userProfile?.is_staff ? menu : !STAFF_ONLY_MENUS.includes(menu),
            )
            .map((menu) => (
              <div
                key={menu}
                style={menuStyle(selectedMenu === menu)}
                onClick={() => handleSelectMenu(menu)}
              >
                {menu}
              </div>
            ))}
        </div>

        <div style={{ width: "85%" }}>
          <CardMeBillingMenuContent
            {...props}
            menu={selectedMenu}
            onSelectMenu={handleSelectMenu}
          />
        </div>
      </div>
    </div>
  );
};

CardMeBillingDetail.displayName = "CardMeBillingDetail";

export default CardMeBillingDetail;
